/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */
import * as React from "react";
import { Box, Text } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { ARAttachedServices } from "~/models/assignmentRule";
import { ARServiceAndGroupAssign } from "./ARServiceAndGroupAssign";
import { ARServiceItem } from "./ARServiceItem";

type AssignmentRuleDetailsServicesProps = {
  attachedServices: ARAttachedServices[];
  fetchAssignmentRule: () => Promise<void>;
  canEdit?: boolean;
};

function AssignmentRuleDetailsServices({
  attachedServices,
  fetchAssignmentRule,
  canEdit,
}: AssignmentRuleDetailsServicesProps) {
  return (
    <Box spacing="spacing04">
      <FlexContainer>
        <Text weight="medium">Services</Text>
        <ARServiceAndGroupAssign
          refetch={fetchAssignmentRule}
          serviceAttachments={attachedServices}
        />
      </FlexContainer>
      {attachedServices?.map((serviceAttachment: ARAttachedServices) => {
        return (
          <ARServiceItem
            serviceAttachment={serviceAttachment}
            key={serviceAttachment?.service?.id}
            refetch={fetchAssignmentRule}
            canEdit={canEdit}
          />
        );
      })}
    </Box>
  );
}

export { AssignmentRuleDetailsServices };
